"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeCustomYouboraDimensions = sanitizeCustomYouboraDimensions;
exports.youboraPluginURL = exports.youboraOptions = void 0;
var _getYouboraPluginURL = require("../utils/getYouboraPluginURL");
// Youbora THEOplayer reference: http://developer.nicepeopleatwork.com/plugins/integration/js-browser/theo-player-2-v6/

var youboraVersion = '6.7.30';
var youboraPluginURL = exports.youboraPluginURL = (0, _getYouboraPluginURL.getYouboraPluginURL)(location.protocol, _getYouboraPluginURL.THEO, youboraVersion);

// Youbora Options reference: http://developer.nicepeopleatwork.com/plugins/general/setting-youbora-options/
// Options expected from config during player initialization:
// - 'accountCode' ('hudl' or 'hudldev')
// - 'username' (Hudl user id)
// - 'platform' or 'extraparam.1' (Platform custom dimension. 'V2' or 'V3')
// - 'entityType' or 'extraparam.2' (Entity custom dimension. 'Video' or 'Playlist')
// - 'sport' or 'extraparam.3' (Sport custom dimension.)
// - 'angleType' or 'extraparam.4' (Angle custom dimension.)
// - 'teamId' or 'extraparam.5' (Hudl user's team id custom dimension.)

var youboraOptions = exports.youboraOptions = {
  // This defaults to true, but we still require a youbora options object (with an accountCode set)
  // in the configuration object passed to the player constructor to actually enable youbora.
  'enabled': true,
  // Parse CDN information from .ts files.
  // http://developer.nicepeopleatwork.com/plugins/general/parse-hls/
  'parse.hls': true,
  // https://hudl-jira.atlassian.net/browse/CV-1583
  // `parse.cdnTTL` default value of 60 seconds, this is the frequency of how often we want to check for cdn switches
  'parse.cdnSwitchHeader': true,
  // Enable CDN node and host detection.
  // http://developer.nicepeopleatwork.com/plugins/general/cdn-node-detection/
  'parse.cdnNodeHost': true,
  'parse.cdnNodeHost.list': ['Cloudfront', 'Fastly', 'Level3', 'Media CDN', 'Stackpath', 'Quantil']
};
function sanitizeCustomYouboraDimensions(options) {
  if (options.platform) {
    options['extraparam.1'] = options.platform;
    delete options.platform;
  }
  if (options.entityType) {
    options['extraparam.2'] = options.entityType;
    delete options.entityType;
  }
  if (options.sport) {
    options['extraparam.3'] = options.sport;
    delete options.sport;
  }
  if (options.angleType) {
    options['extraparam.4'] = options.angleType;
    delete options.angleType;
  }
  if (options.teamId) {
    options['extraparam.5'] = options.teamId;
    delete options.teamId;
  }
  if (options.currentSrc) {
    options['media.title'] = options.currentSrc;
    delete options.currentSrc;
  }
}